export default __webpack_public_path__ + "static/media/Tiger's Gloves of Pierced Flesh.3ed014d9.jpg";